import * as React from 'react';

import type { IconProps } from '../../types';

/**
 * Cardiology icon
 *
 * @category Medical
 */
const Cardiology = React.forwardRef<SVGSVGElement, IconProps>(
  ({ 'data-testid': testId, size = 20, className, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        data-testid={testId}
        width={size}
        height={size}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        role="img"
        aria-hidden="true"
        {...props}
      >
        <path
          fill="currentColor"
          d="M16.943 27.09c-.52 0-.94-.28-1.27-.66-.36-.36-1.02-1.03-1.8-1.81-2.45-2.47-4.33-4.35-5.58-5.61-1.28-1.28-2.57-2.61-3.15-4.38-.26-.79-.35-1.69-.29-2.52.42-5.65 7.13-8.5 11.47-4.88.48.44.77.47 1.23.06.38-.32.8-.6 1.23-.84 4.75-2.59 10.64 1.17 10.31 6.57-.06 1.27-.53 2.49-1.23 3.52-1.16 1.74-2.85 3.07-4.31 4.55-.88.88-4.77 4.79-5.59 5.6-.26.24-.6.4-1.01.41h-.02zm-5.12-20.16c-3.66-.08-6.62 3.76-5.44 7.31.59 1.77 2.07 3.06 3.35 4.36 1.8 1.81 6.25 6.28 7.06 7.1.13.13.18.11.31-.02 1.14-1.13 4.82-4.86 6.62-6.59 1.65-1.58 3.61-3.22 4-5.58.8-5.35-5.62-8.72-9.56-5.02-.36.33-.77.72-1.29.66-.32-.03-.6-.22-.84-.43-1.1-1.11-2.59-1.81-4.18-1.79z"
        />
        <path
          fill="currentColor"
          d="M13.533 19.29c-1.37-.06-1.87-2.62-2.6-3.35-.7-.73-1.15 1.13-2.32 1.27-.65.11-1.19.07-2.01.08h-1.55c-.77-.01-1.46.03-2.19-.03-.59-.04-1.18-.41-.92-.94.37-.68 2.07-.44 2.81-.49h1.63c.67 0 1.13.03 1.61-.07.69-.14 1-.69 1.38-1.25 1.29-1.9 2.12-.82 2.87.75.34.69.69 1.47.95 1.84.35.55.59.09.82-.37.26-.56.54-1.23.8-1.81.52-1.07.88-2.51 1.87-2.53 1.25.2 1.44 2.23 2.24 3.01.5.46 1 .4 1.8.42.98.03 2.46-.1 3.25.14.66.19.78.87.09 1.15-.71.27-1.93.14-2.9.17-.89-.04-2.15.14-2.89-.37-.2-.14-.38-.35-.55-.61-.24-.36-.46-.81-.64-1.13-.15-.26-.29-.43-.44-.43-.39 0-.94 1.64-1.15 2.04-.58 1.22-.88 2.45-1.98 2.51h-.01z"
        />
      </svg>
    );
  }
);

Cardiology.displayName = 'Cardiology';

export { Cardiology };
